import React from 'react';

import { DialogContext } from '@cvt/contexts';

import { Authenticated } from '@modules/Auth/components';


const InviteTeamMemberDialog = React.lazy(() => import('@modules/Users/dialogs/InviteTeamMember').then((m) => ({ default: m.InviteTeamMemberDialog })));
const CreateProjectDialog = React.lazy(() => import('@modules/Projects/dialogs/CreateProjectDialog').then((m) => ({ default: m.CreateProjectDialog })));
const AddSubstageDialog = React.lazy(() => import('@modules/Projects/dialogs/AddSubstageDialog').then((m) => ({ default: m.AddSubstageDialog })));
const AddSubstageTaskDialog = React.lazy(() => import('@modules/Projects/dialogs/AddSubstageTaskDialog').then((m) => ({ default: m.AddSubstageTaskDialog })));
const UploadProjectDocumentDialog = React.lazy(() => import('@modules/Projects/dialogs/UploadProjectDocumentDialog').then((m) => ({ default: m.UploadProjectDocumentDialog })));
const UploadProjectInvoiceDialog = React.lazy(() => import('@modules/Projects/dialogs/UploadProjectInvoiceDialog').then((m) => ({ default: m.UploadProjectInvoiceDialog })));
const AddNoteDialog = React.lazy(() => import('@modules/Projects/dialogs/AddNoteDialog').then((m) => ({ default: m.AddNoteDialog })));
const EditSubstageTaskDialog = React.lazy(() => import('@modules/Projects/dialogs/EditSubstageTaskDialog').then((m) => ({ default: m.EditSubstageTaskDialog })));
const EditProjectDocumentDialog = React.lazy(() => import('@modules/Projects/dialogs/EditProjectDocumentDialog').then((m) => ({ default: m.EditProjectDocumentDialog })));
const EditChecklistAttachmentDialog = React.lazy(() => import('@modules/Projects/dialogs/EditChecklistAttachmentDialog').then((m) => ({ default: m.EditChecklistAttachmentDialog })));
const EditChecklistDialog = React.lazy(() => import('@modules/Projects/dialogs/EditChecklistDialog').then((m) => ({ default: m.EditChecklistDialog })));
const EditSubstageDialog = React.lazy(() => import('@modules/Projects/dialogs/EditSubstageDialog').then((m) => ({ default: m.EditSubstageDialog })));
const MeetingDialog = React.lazy(() => import('@modules/Projects/dialogs/MeetingDialog').then((m) => ({ default: m.MeetingDialog })));
const CreateLeadDialog = React.lazy(() => import('@modules/Leads/dialogs/CreateLeadDialog').then((m) => ({ default: m.CreateLeadDialog })));
const LeadDocumentsDialog = React.lazy(() => import('@modules/Leads/views/Leads/components/LeadDocumentsDialog').then((m) => ({ default: m.LeadDocumentsDialog })));
const LeadNoteDialog = React.lazy(() => import('@modules/Leads/views/Leads/components/LeadNoteDialog').then((m) => ({ default: m.LeadNoteDialog })));
const LeadLostReasonDialog = React.lazy(() => import('@modules/Leads/views/Leads/components/LeadLostReasonDialog').then((m) => ({ default: m.LeadLostReasonDialog })));


export const Dialogs = () => {
  const { openedDialogs, closeDialog, dialogOptions } = React.useContext(DialogContext);
  return (
    <React.Fragment>
      <Authenticated>
        <React.Suspense fallback={null}>
          {!!openedDialogs['inviteTeamMember'] && (
            <InviteTeamMemberDialog open onClose={() => closeDialog('inviteTeamMember')}/>
          )}
          {!!openedDialogs['createProject'] && (
            <CreateProjectDialog open onClose={() => closeDialog('createProject')} options={dialogOptions['createProject']}/>
          )}
          {!!openedDialogs['addSubstage'] && (
            <AddSubstageDialog open onClose={() => closeDialog('addSubstage')} options={dialogOptions['addSubstage']}/>
          )}

          {!!openedDialogs['addSubstageTask'] && (
            <AddSubstageTaskDialog open onClose={() => closeDialog('addSubstageTask')} options={dialogOptions['addSubstageTask']}/>
          )}

          {!!openedDialogs['editSubstageTask'] && (
            <EditSubstageTaskDialog open onClose={() => closeDialog('editSubstageTask')} options={dialogOptions['editSubstageTask']}/>
          )}

          {!!openedDialogs['uploadProjectDocuments'] && (
            <UploadProjectDocumentDialog open onClose={() => closeDialog('uploadProjectDocuments')} options={dialogOptions['uploadProjectDocuments']}/>
          )}

          {!!openedDialogs['editProjectDocument'] && (
            <EditProjectDocumentDialog open onClose={() => closeDialog('editProjectDocument')} options={dialogOptions['editProjectDocument']}/>
          )}

          {!!openedDialogs['uploadProjectInvoices'] && (
            <UploadProjectInvoiceDialog open onClose={() => closeDialog('uploadProjectInvoices')} options={dialogOptions['uploadProjectInvoices']}/>
          )}

          {!!openedDialogs['addNote'] && (
            <AddNoteDialog open onClose={() => closeDialog('addNote')} options={dialogOptions['addNote']}/>
          )}

          {!!openedDialogs['editChecklistAttachment'] && (
            <EditChecklistAttachmentDialog open onClose={() => closeDialog('editChecklistAttachment')} options={dialogOptions['editChecklistAttachment']}/>
          )}

          {!!openedDialogs['editChecklist'] && (
            <EditChecklistDialog open onClose={() => closeDialog('editChecklist')} options={dialogOptions['editChecklist']}/>
          )}

          {!!openedDialogs['editSubstage'] && (
            <EditSubstageDialog open onClose={() => closeDialog('editSubstage')} options={dialogOptions['editSubstage']}/>
          )}

          {!!openedDialogs['addMeeting'] && (
            <MeetingDialog open onClose={() => closeDialog('addMeeting')} options={dialogOptions['addMeeting']}/>
          )}

          {!!openedDialogs['createLead'] && (
            <CreateLeadDialog open onClose={() => closeDialog('createLead')}/>
          )}

          {!!openedDialogs['leadDocuments'] && (
            <LeadDocumentsDialog open onClose={() => closeDialog('leadDocuments')} options={dialogOptions['leadDocuments']}/>
          )}

          {!!openedDialogs['leadNote'] && (
            <LeadNoteDialog open onClose={() => closeDialog('leadNote')} options={dialogOptions['leadNote']}/>
          )}

          {!!openedDialogs['leadLostReason'] && (
            <LeadLostReasonDialog open onClose={() => closeDialog('leadLostReason')} options={dialogOptions['leadLostReason']}/>
          )}
        </React.Suspense>
      </Authenticated>
    </React.Fragment>
  );
};
